























































import {
  Vue,
  Component, Watch, Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import Widget from "@/shared/components/Widget.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import {
  HsabEnrollmentSettingsResponse,
  HsabEnrollmentSettingsUpdateRequest,
  InsuranceClaimSettings
} from "@/shared/types";
import { useThemeStore } from "@/shared/store/theme";

@Component({
  components: {
    Widget,
    GenericLoadingSpinner,
  }
})
export default class HsabEnrollmentSettings extends Vue {
  hsabEnrollmentStore = useHsabEnrollmentStore();
  hsabAccountsStore = useHsabAccountsStore();
  themeStore = useThemeStore();

  enrollmentSettingsTimer = undefined;
  isSaving = false;

  editForm: HsabEnrollmentSettingsUpdateRequest = {
    linkHealthCareData: false,
    autoFileClaim: false,
    autoFileHsa: false
  };

  mounted () {
    this.hsabEnrollmentStore.loadHsabEnrollmentEmployerSettings();
    this.hsabEnrollmentStore.loadPlanYearEnrollmentDetails(true);
  }

  get userOptInSettings (): InsuranceClaimSettings {
    return this.hsabEnrollmentStore.insuranceClaimSettings;
  }

  get employerSettings (): HsabEnrollmentSettingsResponse {
    return this.hsabEnrollmentStore.employerSettings;
  }

  @Watch("hsabEnrollmentStore.insuranceClaimSettings")
  currentSettingsChanged () {
    if (this.userOptInSettings) {
      this.copyFromSettings();
    }
  }

  // User will only be able to update Notional autopay  if the following criteria are met:
  // User has an active notional and EnableAutomaticallyFiled is true
  get canEditAutoPayNotional (): boolean {
    return this.hsabAccountsStore.userHasActiveNotionalAccounts
        && this.employerSettings.enableAutomaticallyFiled;
  }

  // User will only be able to turn on HSA autopay if the following criteria are met
  // User has an active HSA and EnableAutomaticallyFiled is true
  get canEditAutoPayHsa (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount
        && this.employerSettings.enableAutomaticallyFiled;
  }

  saveEnrollmentSettings () {
    this.isSaving = true;
    this.hsabEnrollmentStore.saveHsabEnrollmentSettings(this.editForm)
        .then(() => {
          this.isSaving = false;
        });
  }
  copyFromSettings () {
    this.editForm = {
      linkHealthCareData: this.userOptInSettings.isOptedIn,
      autoFileHsa: this.userOptInSettings.isHsaAutoPayEnabled,
      autoFileClaim: this.userOptInSettings.isNotionalAutoPayEnabled
    };
  }
  handleLinkHealthCareDataChange () {
    if (this.editForm.linkHealthCareData) {
      this.saveEnrollmentSettings();
    } else {
      this.editForm.autoFileClaim = false;
      this.editForm.autoFileHsa = false;
      this.saveEnrollmentSettings();
    }
  }
  handleAutoPayHsaChanged () {
    if (this.editForm.autoFileHsa) {
      this.editForm.autoFileClaim = true;
      this.saveEnrollmentSettings();
    } else {
      this.editForm.autoFileHsa = false;
      this.saveEnrollmentSettings();
    }
  }

  get isLoading (): boolean {
    return this.hsabEnrollmentStore.isEmployerSettingsLoading
        || this.hsabEnrollmentStore.isPlanYearEnrollmentDataLoading;
  }

  get isLoaded (): boolean {
    return this.hsabEnrollmentStore.isEmployerSettingsLoaded
        && this.hsabEnrollmentStore.isPlanYearEnrollmentDataLoaded;
  }

  get loadingFailed (): boolean {
    return this.hsabEnrollmentStore.isEmployerSettingsFetchStateFailed
        || this.hsabEnrollmentStore.isPlanYearEnrollmentDataFetchStateFailed;
  }

  get optInDisabled () {
    return this.isSaving;
  }

  get autoFileNotionalDisabled () {
    return this.isSaving || !this.editForm.linkHealthCareData;
  }

  get autoFileHsaDisabled (): boolean {
    return this.isSaving
        || !this.editForm.linkHealthCareData
        || (this.hsabAccountsStore.userHasActiveNotionalAccounts && !this.editForm.autoFileClaim);
  }

  handleAutoSpendingAccountChanged () {
    if (this.editForm.autoFileClaim) {
      this.saveEnrollmentSettings();
    } else {
      this.editForm.autoFileHsa = false;
      this.saveEnrollmentSettings();
    }
  }
}
